import React from "react";
import { Bs1SquareFill, Bs8CircleFill, BsAndroid, BsGithub, BsLinkedin, BsPerson } from "react-icons/bs";
import { images } from "../constants";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://github.com/gaurav7yadav" target="_blank">
          <BsGithub />
        </a>
      </div>
      <div>
        <a href="https://www.linkedin.com/in/gaurav-yadav-7645b4230/" target="_blank">
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://leetcode.com/gaurav_7_yadav/" target="_blank">
          <BsAndroid />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
